export const imageSizeCheck = (image: Object) => {
  const fileSize = Math.round(image?.size || 0)
  const fileSizeIsBigEnough = fileSize > 1500
  const dimensionAreBigEnough = image?.width > 2000 || image?.height > 2000
  return fileSizeIsBigEnough || dimensionAreBigEnough
}
